import type { ClientPropertyFlatDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { mapPropertyToBuildingForm } from "web_myplann/Portfolio/Forms/BuildingShared/mapPropertyToBuildingForm";
import type { FlatFormInput } from "web_myplann/Portfolio/Forms/FlatForm/flatFormSchema";

export const mapPropertyToFlatForm = (
	property: ClientPropertyFlatDetailResponseDTO,
): FlatFormInput =>
	mapPropertyToBuildingForm(property, property.numberOfAboveGroundFloors);
